import { render, staticRenderFns } from "./PayVhIn.vue?vue&type=template&id=2b92285a&scoped=true"
import script from "./PayVhIn.vue?vue&type=script&lang=js"
export * from "./PayVhIn.vue?vue&type=script&lang=js"
import style0 from "./PayVhIn.vue?vue&type=style&index=0&id=2b92285a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b92285a",
  null
  
)

export default component.exports